import { STATUS_LABELS, type OrderStatus } from '../domain/status.ts';
import { MarqueeText } from './MarqueeText.tsx';

// Estado con color y etiqueta (nunca solo color, §12). Si la etiqueta no cabe, el texto se desliza solo.
export function StatusBadge({ status }: { status: OrderStatus }) {
  return (
    <span className={`status status-${status}`}>
      <MarqueeText>{STATUS_LABELS[status]}</MarqueeText>
    </span>
  );
}
